import React, { useState } from 'react';
import styles from './CertificateInstruction.module.scss';
import { useScopedTranslation } from '../../../application/localization/useScopedTranslation.ts';
import { Breadcrumbs } from '../../../components/uikit/Breadcrumbs.tsx';
import clsx from 'clsx';
import Step1Image from 'assets/img/certificate-instruction-step1.svg';
import Step2Image from 'assets/img/certificate-instruction-step2.svg';
import Step3Image from 'assets/img/certificate-instruction-step3.svg';
import Step4Image from 'assets/img/certificate-instruction-step4.svg';
import Step5Image from 'assets/img/certificate-instruction-step5.svg';
import Step6Image from 'assets/img/certificate-instruction-step6.svg';
import Step7Image from 'assets/img/certificate-instruction-step7.svg';
import Step8Image from 'assets/img/certificate-instruction-step8.svg';
import Step9Image from 'assets/img/certificate-instruction-step9.svg';
import Step10Image from 'assets/img/certificate-instruction-step10.svg';
import StatusFailed from 'assets/icons/status_failed.svg?react';
import { Step } from '../../../components/uikit/Step.tsx';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Links } from '../../../application/constants/links.ts';
import MailIcon from 'assets/icons/mail.svg?react';
import SuccessIcon from 'assets/icons/success.svg?react';
import { ActionText } from '../../../components/uikit/ActionText.tsx';
import CloseIcon from 'assets/icons/close-button.svg?react';

type CertificateStepKey =
  | 'step_1'
  | 'step_2'
  | 'step_3'
  | 'step_4'
  | 'step_5'
  | 'step_6'
  | 'step_7'
  | 'step_8'
  | 'step_9'
  | 'step_10';

type Step = {
  textKey: CertificateStepKey;
  image: string;
  imageClassName?: string;
};

const steps: Step[] = [
  {
    textKey: 'step_1',
    image: Step1Image,
  },
  {
    textKey: 'step_2',
    image: Step2Image,
  },
  {
    textKey: 'step_3',
    image: Step3Image,
  },
  {
    textKey: 'step_4',
    image: Step4Image,
    imageClassName: styles.width70,
  },
  {
    textKey: 'step_5',
    image: Step5Image,
  },
  {
    textKey: 'step_6',
    image: Step6Image,
  },
  {
    textKey: 'step_7',
    image: Step7Image,
    imageClassName: styles.width60,
  },
  {
    textKey: 'step_8',
    image: Step8Image,
  },
  {
    textKey: 'step_9',
    image: Step9Image,
  },
  {
    textKey: 'step_10',
    image: Step10Image,
  },
];

const email = 'TechnischerService@Löwensteinmedical.de';

export const CertificateInstruction = () => {
  const i18n = useScopedTranslation('Page.CertificateInstruction');

  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  return (
    <div>
      <Breadcrumbs />
      <div className={clsx(styles.title, styles.marginBottom24)}>
        {i18n.t('title')}
      </div>
      <div className={clsx(styles.text, styles.marginBottom24)}>
        {i18n.t('description')}
      </div>
      <div className={clsx(styles.container, styles.marginBottom48)}>
        {steps.map((step, index) => {
          return (
            <div key={step.textKey} className={clsx(styles.item)}>
              <div className={styles.stepTextContainer}>
                <Step
                  className={styles.stepNumber}
                  value={index + 1}
                  isActive={true}
                  Svg={index + 1 === steps.length ? SuccessIcon : undefined}
                  imageClassName={styles.successIcon}
                />
                <div className={styles.text}>
                  <Trans
                    i18nKey={`Page.CertificateInstruction.${step.textKey}`}
                    components={{
                      bold: <strong />,
                      a: (
                        <Link
                          to={Links.Authorized.MainboardReplacerForm.route}
                          className={styles.link}
                        />
                      ),
                    }}
                  />
                </div>
              </div>
              <div
                className={clsx(styles.imageContainer)}
                onClick={() => setSelectedImage(step.image)}
              >
                <img
                  src={step.image}
                  className={clsx(styles.image, step.imageClassName)}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className={clsx(styles.title, styles.marginBottom16)}>
        {i18n.t('processing_title')}
      </div>
      <div className={styles.signingFailedContainer}>
        <div className={clsx(styles.rowContainer, styles.columnGap8)}>
          <StatusFailed />
          <div className={styles.signingFailedTitle}>
            {i18n.t('signing_failed_title')}
          </div>
        </div>
        <div className={clsx(styles.text, styles.marginLeft28)}>
          {i18n.t('signing_failed_text')}
        </div>
      </div>
      <div className={clsx(styles.title, styles.marginBottom16)}>
        {i18n.t('contacts_title')}
      </div>
      <div className={clsx(styles.text, styles.marginBottom16)}>
        {i18n.t('contacts_text')}
      </div>
      <div className={styles.contactsContainer}>
        <Link to={'mailto:' + email} className={styles.textDecorationNone}>
          <ActionText text={email} Svg={MailIcon} />
        </Link>
      </div>
      {!!selectedImage && (
        <div className={styles.selectedImageWrapper}>
          <div className={styles.selectedImageContainer}>
            <img
              className={clsx(styles.image, styles.objectFitContain)}
              src={selectedImage}
            />
            <CloseIcon
              className={styles.crossIcon}
              onClick={() => setSelectedImage(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};
